// Generated by domeleonGen/generateDom.ts - Do not edit manually!
import { h } from './html.js'
import type { HValues } from './html.js'

export function a(...values: HValues[]) { return h("a", ...values) }
export function abbr(...values: HValues[]) { return h("abbr", ...values) }
export function address(...values: HValues[]) { return h("address", ...values) }
export function area(...values: HValues[]) { return h("area", ...values) }
export function article(...values: HValues[]) { return h("article", ...values) }
export function aside(...values: HValues[]) { return h("aside", ...values) }
export function audio(...values: HValues[]) { return h("audio", ...values) }
export function b(...values: HValues[]) { return h("b", ...values) }
export function base(...values: HValues[]) { return h("base", ...values) }
export function bdi(...values: HValues[]) { return h("bdi", ...values) }
export function bdo(...values: HValues[]) { return h("bdo", ...values) }
export function blockquote(...values: HValues[]) { return h("blockquote", ...values) }
export function body(...values: HValues[]) { return h("body", ...values) }
export function br(...values: HValues[]) { return h("br", ...values) }
export function button(...values: HValues[]) { return h("button", ...values) }
export function canvas(...values: HValues[]) { return h("canvas", ...values) }
export function caption(...values: HValues[]) { return h("caption", ...values) }
export function cite(...values: HValues[]) { return h("cite", ...values) }
export function code(...values: HValues[]) { return h("code", ...values) }
export function col(...values: HValues[]) { return h("col", ...values) }
export function colgroup(...values: HValues[]) { return h("colgroup", ...values) }
export function data(...values: HValues[]) { return h("data", ...values) }
export function datalist(...values: HValues[]) { return h("datalist", ...values) }
export function dd(...values: HValues[]) { return h("dd", ...values) }
export function del(...values: HValues[]) { return h("del", ...values) }
export function details(...values: HValues[]) { return h("details", ...values) }
export function dfn(...values: HValues[]) { return h("dfn", ...values) }
export function dialog(...values: HValues[]) { return h("dialog", ...values) }
export function div(...values: HValues[]) { return h("div", ...values) }
export function dl(...values: HValues[]) { return h("dl", ...values) }
export function dt(...values: HValues[]) { return h("dt", ...values) }
export function em(...values: HValues[]) { return h("em", ...values) }
export function embed(...values: HValues[]) { return h("embed", ...values) }
export function fieldset(...values: HValues[]) { return h("fieldset", ...values) }
export function figcaption(...values: HValues[]) { return h("figcaption", ...values) }
export function figure(...values: HValues[]) { return h("figure", ...values) }
export function footer(...values: HValues[]) { return h("footer", ...values) }
export function form(...values: HValues[]) { return h("form", ...values) }
export function h1(...values: HValues[]) { return h("h1", ...values) }
export function h2(...values: HValues[]) { return h("h2", ...values) }
export function h3(...values: HValues[]) { return h("h3", ...values) }
export function h4(...values: HValues[]) { return h("h4", ...values) }
export function h5(...values: HValues[]) { return h("h5", ...values) }
export function h6(...values: HValues[]) { return h("h6", ...values) }
export function head(...values: HValues[]) { return h("head", ...values) }
export function header(...values: HValues[]) { return h("header", ...values) }
export function hgroup(...values: HValues[]) { return h("hgroup", ...values) }
export function hr(...values: HValues[]) { return h("hr", ...values) }
export function html(...values: HValues[]) { return h("html", ...values) }
export function i(...values: HValues[]) { return h("i", ...values) }
export function iframe(...values: HValues[]) { return h("iframe", ...values) }
export function img(...values: HValues[]) { return h("img", ...values) }
export function input(...values: HValues[]) { return h("input", ...values) }
export function ins(...values: HValues[]) { return h("ins", ...values) }
export function kbd(...values: HValues[]) { return h("kbd", ...values) }
export function label(...values: HValues[]) { return h("label", ...values) }
export function legend(...values: HValues[]) { return h("legend", ...values) }
export function li(...values: HValues[]) { return h("li", ...values) }
export function link(...values: HValues[]) { return h("link", ...values) }
export function main(...values: HValues[]) { return h("main", ...values) }
export function map(...values: HValues[]) { return h("map", ...values) }
export function mark(...values: HValues[]) { return h("mark", ...values) }
export function menu(...values: HValues[]) { return h("menu", ...values) }
export function meta(...values: HValues[]) { return h("meta", ...values) }
export function meter(...values: HValues[]) { return h("meter", ...values) }
export function nav(...values: HValues[]) { return h("nav", ...values) }
export function noscript(...values: HValues[]) { return h("noscript", ...values) }
export function object(...values: HValues[]) { return h("object", ...values) }
export function ol(...values: HValues[]) { return h("ol", ...values) }
export function optgroup(...values: HValues[]) { return h("optgroup", ...values) }
export function option(...values: HValues[]) { return h("option", ...values) }
export function output(...values: HValues[]) { return h("output", ...values) }
export function p(...values: HValues[]) { return h("p", ...values) }
export function picture(...values: HValues[]) { return h("picture", ...values) }
export function pre(...values: HValues[]) { return h("pre", ...values) }
export function progress(...values: HValues[]) { return h("progress", ...values) }
export function q(...values: HValues[]) { return h("q", ...values) }
export function rp(...values: HValues[]) { return h("rp", ...values) }
export function rt(...values: HValues[]) { return h("rt", ...values) }
export function ruby(...values: HValues[]) { return h("ruby", ...values) }
export function s(...values: HValues[]) { return h("s", ...values) }
export function samp(...values: HValues[]) { return h("samp", ...values) }
export function script(...values: HValues[]) { return h("script", ...values) }
export function search(...values: HValues[]) { return h("search", ...values) }
export function section(...values: HValues[]) { return h("section", ...values) }
export function select(...values: HValues[]) { return h("select", ...values) }
export function slot(...values: HValues[]) { return h("slot", ...values) }
export function small(...values: HValues[]) { return h("small", ...values) }
export function source(...values: HValues[]) { return h("source", ...values) }
export function span(...values: HValues[]) { return h("span", ...values) }
export function strong(...values: HValues[]) { return h("strong", ...values) }
export function style(...values: HValues[]) { return h("style", ...values) }
export function sub(...values: HValues[]) { return h("sub", ...values) }
export function summary(...values: HValues[]) { return h("summary", ...values) }
export function sup(...values: HValues[]) { return h("sup", ...values) }
export function table(...values: HValues[]) { return h("table", ...values) }
export function tbody(...values: HValues[]) { return h("tbody", ...values) }
export function td(...values: HValues[]) { return h("td", ...values) }
export function template(...values: HValues[]) { return h("template", ...values) }
export function textarea(...values: HValues[]) { return h("textarea", ...values) }
export function tfoot(...values: HValues[]) { return h("tfoot", ...values) }
export function th(...values: HValues[]) { return h("th", ...values) }
export function thead(...values: HValues[]) { return h("thead", ...values) }
export function time(...values: HValues[]) { return h("time", ...values) }
export function title(...values: HValues[]) { return h("title", ...values) }
export function tr(...values: HValues[]) { return h("tr", ...values) }
export function track(...values: HValues[]) { return h("track", ...values) }
export function u(...values: HValues[]) { return h("u", ...values) }
export function ul(...values: HValues[]) { return h("ul", ...values) }
export function video(...values: HValues[]) { return h("video", ...values) }
export function wbr(...values: HValues[]) { return h("wbr", ...values) }
